// Copyright (c) Docugami, Inc. All rights reserved.

import { Shimmer, ShimmerElementType } from "@fluentui/react";
import { Property } from "hooks/documentProperties";
import styled from "styled-components";
import { PropertyItem } from "./propertyItem";

const PropertiesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    box-sizing: border-box;
    height: fit-content;
    width: 100%;
`

interface DocumentPropertiesViewerProps {
    properties: Property[];
    isLoading?: boolean;
    selected?: Property;
    onSelect: (p?: Property) => void;
    onDelete: (p: Property) => void;
    onEdit: (p: Property) => void;
    canDrag: (p: Property) => boolean;
    onDragStart: (p: Property) => void;
    onDragEnd: (p: Property) => void;
}

export const DocumentPropertiesViewer = (props: DocumentPropertiesViewerProps): JSX.Element => {
    const loadingItems: JSX.Element[] = [
        <LoadingPropertyItem key="loading_1" />,
        <LoadingPropertyItem key="loading_2" />,
        <LoadingPropertyItem key="loading_3" />,
    ];

    return (
        <PropertiesContainer>
            {!!props.isLoading ?
                loadingItems :
                props.properties.map(property => {
                    return (
                        <PropertyItem
                            key={property.spanId}
                            property={property}
                            isSelected={props.selected?.spanId === property.spanId}
                            onClick={() => !!property.value ? props.onSelect(property) : props.onEdit(property)}
                            onDelete={() => props.onDelete(property)}
                            onEdit={() => props.onEdit(property)}
                            isDraggable={props.canDrag(property)}
                            onDragStart={() => props.onDragStart(property)}
                            onDragEnd={() => props.onDragEnd(property)} />
                    )
                })
            }
        </PropertiesContainer>
    )
}

const LoadingPropertyItem = (): JSX.Element => {
    return (
        <Shimmer
            styles={{
                root: {
                    borderRadius: 5
                }
            }}
            shimmerElements={[
                {
                    type: ShimmerElementType.line,
                    width: "100%",
                    height: 35
                }
            ]} />
    )
}
